<div class="new-insured-page parallax-container">

    <div class="banner-section">
      <span class="about-banner-text">
        <span>Protección de viaje</span>
        <span>integral que se adapta a tus</span>
        <span>necesidades</span>
        <!-- <img src="./assets/img/insure-animat.png" alt="Banner" class="banner-image mobile-none">
        <img src="./assets/img/mobile-insured-page-bg-2.png" alt="Banner" class="web-none banner-image"> -->
        <div class="banner-image-separate">
          <img src="./assets/img/Ball-Pink.png" alt="Banner" id="Ball-Pink" class="parallax-image">
          <img src="./assets/img/Bone-Purpple.png" alt="Banner" id="Bone-Purpple" class="parallax-image">
          <img src="./assets/img/Eiffel-White.png" alt="Banner" id="Eiffel-White" class="parallax-image">
          <img src="./assets/img/Luggage-Purpple.png" alt="Banner" id="Luggage-purpple" class="parallax-image">
          <img src="./assets/img/Pill-Silver-Right.png" alt="Banner" id="Pill-Silver-Right" class="parallax-image">
          <img src="./assets/img/Sphere-Silver.png" alt="Banner" id="Sphere-Silver" class="parallax-image">
        </div>
      </span>
      
      <!-- <img src="./assets/img/mobile-insured-page-bg.png" alt="Banner" class="web-none"> -->
    </div>
    <div class="container mobile-padding">
    <div class="tab-section">
      <!-- Menu de pastillas (propuesta 1, 2026-10-18): fijo bajo el header al desplazarse; el banner de arriba no cambia -->
      <div class="tab-section-content"><div class="tab-seg">
        <div class="insured-component36 px-3" [class.active]="activeTab === 'contactIdIsured'" (click)="setActiveTab('contactIdIsured')"><svg class="tab-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"/></svg>
          <div class="insured-frame9611 py-2">
            <div class="insured-frame9711">
              <span class="insured-text170 Mob,H2,Bold12">
                <span class="mobile-hide">Contáctenos</span>
                <span class="web-hide">Contacto</span>
              </span>
            </div>
          </div>
        </div>
        <div class="insured-component36 px-3" [class.active]="activeTab === 'notiIsured'" (click)="setActiveTab('notiIsured')"><svg class="tab-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 2 20h20L12 3z"/><path d="M12 10v4M12 17v.5"/></svg>
          <div class="insured-frame9611 py-2">
            <div class="insured-frame9711">
              <span class="insured-text170 Mob,H2,Bold12">
                <span class="mobile-hide">¿Como proceder ante una Emergencia?</span>
                <span class="web-hide">Emergencia</span>
              </span>
            </div>
          </div>
        </div>
        <div class="insured-component36 px-3" [class.active]="activeTab === 'claimInsured'" (click)="setActiveTab('claimInsured')"><svg class="tab-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h8l4 4v14H6z"/><path d="M14 3v4h4M9 12h6M9 16h6"/></svg>
          <div class="insured-frame9611 py-2">
            <div class="insured-frame9711">
              <span class="insured-text170 Mob,H2,Bold12">
                <span class="mobile-hide">Proceso de Reclamación</span>
                <span class="web-hide">Reclamos</span>
              </span>
            </div>
          </div>
        </div>
        <div class="insured-component36 px-3" [class.active]="activeTab === 'certificateInsured'" (click)="setActiveTab('certificateInsured')"><svg class="tab-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4v11M7 10l5 5 5-5"/><path d="M4 19h16"/></svg>
          <div class="insured-frame9611 py-2">
            <div class="insured-frame9711">
              <span class="insured-text170 Mob,H2,Bold12">
                <span class="mobile-hide">Documentos</span>
                <span class="web-hide">Documentos</span>
              </span>
            </div>
          </div>
        </div>
      </div></div>
      <div class="white-box">
        <span *ngIf="activeTab !== 'certificateInsured'">Para obtener su cobertura debe de notificar su emergencia dentro de las primeras 24 horas del evento.</span>
        <span *ngIf="activeTab === 'certificateInsured'">Para obtener su certificado debe iniciar sesión</span>
      </div>
      <div class="tab-section-content-item">
        <!-- contactIdIsured -->
        <div class="" [hidden]="activeTab !== 'contactIdIsured'">
          <div class="" id="contactIdIsured">
            <div class="contact-section">
              <div class="contact-section-heading">
                <i>
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none">
                    <ellipse cx="17.687" cy="17.3753" rx="17.687" ry="17.3753" fill="#2828E0"/>
                    <path d="M25.0874 20.2741C24.3404 19.8883 23.7945 19.6509 23.4066 19.5025C23.1623 19.4135 22.5876 19.1464 22.3865 19.3096C21.7544 19.8438 21.0791 21.3572 20.3608 21.6391C18.5793 21.283 16.9271 20.0218 15.6341 18.731C15.0594 18.1671 13.9963 16.5647 13.7664 16.1344C13.7233 15.6893 14.4991 15.0957 14.6715 14.7545C15.5622 13.7159 14.887 13.063 14.7721 12.6327C14.571 12.1876 14.2262 11.3863 13.9245 10.7335C13.6659 10.3032 13.6083 9.66518 13.1486 9.42778C11.1947 8.38915 10.0742 10.4664 9.61442 11.5496C6.84162 18.449 23.5071 31.5803 26.8977 22.5294C27.0701 21.743 26.9982 21.4462 26.7396 21.0901C26.2224 20.7192 25.619 20.556 25.0874 20.2741Z" fill="white" stroke="white" stroke-width="0.91449"/>
                  </svg>
                </i>
                <div>
                  <span class="contact-section-title">Emergencias 24/7</span>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-md-3 col-6">
                  <div class="contact-detail">
                    <span>Resto del mundo- Worldwide</span>
                    <a href="tel:+13059611659">+1 (305) 961-1659</a>
                  </div>
                </div>
                <div class="col-md-3 col-6">
                  <div class="contact-detail">
                    <span>USA &amp; Canada</span>
                    <a href="tel:+18888924888">+1 888 892-4888</a>
                  </div>
                </div>
                <div class="col-md-3 col-6">
                  <div class="contact-detail">
                    <span>Whats App</span>
                    <a href="tel:+13052328881">+1 (305) 232-8881</a>
                  </div>
                </div>
                <div class="col-md-3 col-6">
                  <div class="contact-detail">
                    <span>Correo Electrónico</span>
                    <a href="mailto:service&#64;blueassist.biz">service&#64;blueassist.biz</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-section">
              <div class="contact-section-heading">
                <i>
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none">
                    <ellipse cx="17.687" cy="17.3753" rx="17.687" ry="17.3753" fill="#2828E0"/>
                    <path d="M25.0874 20.2741C24.3404 19.8883 23.7945 19.6509 23.4066 19.5025C23.1623 19.4135 22.5876 19.1464 22.3865 19.3096C21.7544 19.8438 21.0791 21.3572 20.3608 21.6391C18.5793 21.283 16.9271 20.0218 15.6341 18.731C15.0594 18.1671 13.9963 16.5647 13.7664 16.1344C13.7233 15.6893 14.4991 15.0957 14.6715 14.7545C15.5622 13.7159 14.887 13.063 14.7721 12.6327C14.571 12.1876 14.2262 11.3863 13.9245 10.7335C13.6659 10.3032 13.6083 9.66518 13.1486 9.42778C11.1947 8.38915 10.0742 10.4664 9.61442 11.5496C6.84162 18.449 23.5071 31.5803 26.8977 22.5294C27.0701 21.743 26.9982 21.4462 26.7396 21.0901C26.2224 20.7192 25.619 20.556 25.0874 20.2741Z" fill="white" stroke="white" stroke-width="0.91449"/>
                  </svg>
                </i>
                <div>
                  <span class="contact-section-title">Soporte Administrativo y Ventas</span>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-md-3 col-6">
                  <div class="contact-detail">
                    <span>Resto del mundo- Worldwide</span>
                    <a href="tel:+13057790248">+1 (305) 779-0248</a>
                  </div>
                </div>
                <div class="col-md-3 col-6">
                  <div class="contact-detail">
                    <span>Correo Electrónico</span>
                    <a href="mailto:clientsupport&#64;blueassist.biz">clientsupport&#64;blueassist.biz</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- contactIdIsured  -->
         <!-- notiIsured -->
        <div class="" [hidden]="activeTab !== 'notiIsured'">
          <div class="" id="notiIsured">
            <div class="row justify-content-center">
              <div class="col-md-7">
                <div class="notiIsured-card background-greys">
                  <span class="web-none notiIsured-card-number">1.</span>
                  <h1><span class="mobile-none">Paso 1</span> <span>Comuniquenos su emergencia</span></h1>
                  <span class="web-none notiIsured-notification">Notificación de Emergencia</span>
                  <p>Reporte su emergencia médica dentro de las primeras 24 horas para obtener pago y coordinación directa con el proveedor. Tenga a mano la siguiente información: </p>
                  <ul>
                    <li>Nombre completo</li>
                    <li>Número de certificado</li>
                    <li>Fechas del viaje</li>
                    <li>Copia de pasaporte y boleto de embarque.</li>
                    <li>Tipo de asistencia requerida</li>
                    <li>País de residencia permanente</li>
                    <li>Número de teléfono y lugar donde pueda ser ubicado</li>
                  </ul> 
                </div>
              </div>
              <div class="col-md-5">
                <div class="notiIsured-card background-whites">
                  <span class="web-none notiIsured-card-number">2.</span>
                  <h1><span class="mobile-none">Paso 2</span> <span>Le aportamos una solución</span></h1>
                  <span class="web-none notiIsured-notification">Notificación de Emergencia</span>
                  <p>Nuestra Central de Asistencia le coordinará una visita de un médico o al Centro Hospitalario más cercano al cual dirigirse.</p>
                  <p>Para servicios de asistencia no medica, comuníquese con nuestra Central de Asistencia para asistirle en coordinar los beneficios de su plan.  </p>                  
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- notiIsured -->
         <!-- claimInsured -->
        <div class="" [hidden]="activeTab !== 'claimInsured'">
          <div class="" id="claimInsured">
              <div class="claimInsured-data">
                <div class="row">
                  <div class="col-md-4">
                    <div class="claimInsured-data-inner">
                      <div class="claimInsured-data-top">
                        <span>1.</span>
                        <div class="share-icon">
                          <a href="#"><img src="../../../assets/img/bag.png" /></a>
                          <a href="#"><img src="../../../assets/img/hart.png" /></a>
                        </div>
                      </div>
                      <h2>Evidencia del Viaje</h2>
                      <p>Evidencia del viaje, incluyendo copia de las páginas del pasaporte,  facturas de gastos y boletos de ida y vuelta.</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="claimInsured-data-inner active">
                      <div class="claimInsured-data-top">
                        <span>2.</span>
                        <div class="share-icon">
                          <a href="#"><img src="../../../assets/img/bag.png" /></a>
                          <a href="#"><img src="../../../assets/img/hart.png" /></a>
                        </div>
                      </div>
                      <h2>Formulario de Reclamación</h2>
                      <p>Formulario de Reclamación debidamente completado y firmado por el paciente.
                      </p>
                      <a href="/assets/docs/Claim_Form_para_BLUEASSIST.pdf" target="_blank" download class="descargar-btn">Descargar</a>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="claimInsured-data-inner">
                      <div class="claimInsured-data-top">
                        <span>3.</span>
                        <div class="share-icon">
                          <a href="#"><img src="../../../assets/img/bag.png" /></a>
                          <a href="#"><img src="../../../assets/img/hart.png" /></a>
                        </div>
                      </div>
                      <h2>Reporte Médico</h2>
                      <p>Reporte Médico que incluya notas del médico tratante, pruebas de diagnóstico, reportes de radiología y resonancia magnética, prescripciones o recetas médicas, entre otros.</p>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <!-- claimInsured -->
        <!-- certificateInsured -->
        <div class="" [hidden]="activeTab !== 'certificateInsured'">
          <div class=""  id="certificateInsured">
              <div class="row">
                <div class="col-md-3">
                  <div class="claimInsured-data-inner">
                    <h2>Brochure de venta</h2>
                    <a href="/assets/docs/BAC-Blue Assist-Brochure-0630o.pdf" target="_blank" download class="descargar-btn">Descargar</a>
                  </div>
                </div>
                <!-- <div class="col-md-3">
                  <div class="claimInsured-data-inner">
                    <h2>Condicionado de asistencia </h2>
                    <a href="#" class="descargar-btn">Descargar</a>
                  </div>
                </div> -->
              </div>
          </div>
        </div>
        <!-- certificateInsured -->
      </div>
          
  
  <!-- Emergency Notification Section -->
  
 
  
  <!-- <div class="row mx-0 align-center-center"  >
    <div class="col-12 col-md-10 col-lg-9">
        <div class="row justify-content-center">
          <div class="col-12 col-md-12 col-lg-12 col-xl-3 pb-5">
            <div class="card custom-card-middle custom-card-middle-blue-border border-grey shadow-lg">
                <div class="card-body px-5 py-0 align-center-center">
                  <div class="row w-100 d-flex align-items-center pt-2">
                    <div class="col-12 d-flex flex-column px-0 py-5">
                      <div class="row w-100">
                          <div class="col-12 align-space-between px-0 border-blue pb-2">
                            <span class="tittle-card-style">Servicio de Remolque</span>
                            <span class="tittle-card-style tittle-circle">+</span>
                          </div>
                      </div>
                      <div class="row w-100 pt-3 ">
                        <div class="col-12 justify-content-start px-0">
                          <span class="tittle-card-style" style="font-weight: 500;">Copia del contrato de alquiler del vehículo, factura de la compañía de remolque y evidencia del pago.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div class="col-12 col-md-12 col-lg-12 col-xl-3 pb-5">
            <div class="card custom-card-middle background-middle-blue shadow-lg">
                <div class="card-body px-5 py-0 align-center-center">
                  <div class="row w-100 d-flex align-items-center pt-2">
                    <div class="col-12 d-flex flex-column px-0 py-5">
                      <div class="row w-100">
                          <div class="col-12 align-space-between px-0 border-bottom-white pb-2">
                            <span class="tittle-card-style text-color-white">Boletos pasaje</span>
                            <span class="tittle-card-style tittle-circle-dark-blue text-color-white">+</span>
                          </div>
                      </div>
                      <div class="row w-100 pt-3 ">
                        <div class="col-12 justify-content-start px-0">
                          <span class="tittle-card-style text-color-white" style="font-weight: 500;">Entregar el segmento del pasaje no utilizado a la Compañía, siempre que la Compañía tenga que pagar el costo de un pasaje.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div class="col-12 col-md-12 col-lg-12 col-xl-6 pb-5">
            <div class="card custom-card-middle background-grey shadow-lg">
                <div class="card-body px-5 py-0 align-center-center">
                  <div class="row w-100 d-flex align-items-center pt-2">
                    <div class="col-12 d-flex flex-column px-0 py-5">
                      <div class="row w-100">
                          <div class="col-12 align-space-between px-0 border-blue pb-2">
                            <span class="tittle-card-style">Pérdida | Demora de Equipaje</span>
                            <span class="tittle-card-style tittle-circle text-color-white">+</span>
                          </div>
                      </div>
                      <div class="row w-100 pt-3 ">
                        <div class="col-12 justify-content-start px-0">
                          <span class="tittle-card-style " style="font-weight: 500;">Reporte de Irregularidad de Propiedad (PIR), copia de la
                            etiqueta de control/identificación del equipaje y constancia
                            del transportista aceptando su responsabilidad por la
                            pérdida/demora del equipaje. Esta cobertura no aplicará en
                            caso de que el transportista pague por el valor del contenido
                            del equipaje.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
    </div>
  </div> -->
 
</div>